import type { RunDialogPageProps } from "..";
import { useRunDialogContext } from "../context";
import { MDXPageWithToc } from "../mdx-page-with-toc";
import ModelAPI from "../model-api.mdx";

export function ModelAPIPage({ version }: RunDialogPageProps) {
  const { language } = useRunDialogContext();

  return (
    <MDXPageWithToc id="schema" language={language} key={language}>
      <ModelAPI
        // @ts-ignore
        version={version}
      />
    </MDXPageWithToc>
  );
}
